import { Toolbar, Card, Box, CardContent, Button, Grid, Stack } from "@mui/material";
import React from "react";
import { ShowInfoConfirmation, ShowInfoNotification, ShowWarningConfirmation, ShowWarningNotification, SibaDatePicker, SibaInput, SibaSelect, SibaTextArea } from "@siba/components";
import "../../AuthForm/Login/Login.css";
import { useGenericFormMethods } from "Application/Pages/formMethods/genericMethods";
import { BidderRegister } from "Application/features/models/Home/BidderRegister";
import { useSaveBidderRegisterMutation } from "Application/features/services/apis/Home/BidderRegisterApiService";
import { growlError, growlWarning, userManagementUtil } from "@siba/utilities";
import { UseFormReturn, FieldValues } from "react-hook-form";
import * as Icons from "react-feather";
import { useSignUpMutation } from "Application/features/services/apis/Home/UserApiService";
import { IUser } from "Application/features/models/Home/IUser";
import { queryResponse } from "Application/features/services/backends/sibaApis";
import Typography from "@material-ui/core/Typography";
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import { useNavigate } from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import baseUrl from '../../../features/services/service';

const BidderRegistrationForm: React.FC = () => {
    const [save] = useSaveBidderRegisterMutation();
    const [signUpAccount] = useSignUpMutation();
    const bidderRegisterFormMethods = useGenericFormMethods<BidderRegister>({ saveMethod: save as any });
    
    const navigate = useNavigate();
    const navigateToLoginPage = () => {
        // 👇️ navigate to /contacts
        navigate('/login');
      };

      
    /**
     * genericMethods is generic method, property  generator tha returns
     * default/ generic event handlers for a setup form.
     * @prop Name is defaulted as the name of the setup and shown on the form.
     * @prop saveMethod - a save endpoint/ function for the setup.
     * @prop removeMethod - points to the remove method, endpoint for the setup.
     * @prop updateMethod - points to the update method / endpont for the setup.
     * @returns generic methods / properties for setup form.
     * @type IUser
     * **/
    const userGenericMethods = useGenericFormMethods<IUser>({
        saveMethod: signUpAccount as any
    });
    const {
        formState: { errors }
    } = bidderRegisterFormMethods.formHandler;

    const bidderRegisteration = () => {
        submitBidderInfo(bidderRegisterFormMethods.formHandler);
    };
    const submitBidderInfo = (formHandler: UseFormReturn<FieldValues, object>) => {
        formHandler.handleSubmit(
            async (data) => {
                data.FullName = `${userManagementUtil.getUserSession().firstName} ${userManagementUtil.getUserSession().lastName}`;
                const formData = data as BidderRegister;
                formData.Status = 1;
                formData.ExternalUserId = userManagementUtil.getUserId();
                formData.Email = userManagementUtil.getUserSession().email;
                formData.PhoneNumber = userManagementUtil.getUserSession().phoneNumber;
                if (save) {
                    ShowInfoConfirmation("Submit final registration step?", async () => {
                        const response: queryResponse<any> | any = await save(formData);
                        if (response.state) {
                            ShowInfoNotification("You are almost there!, kindly logout and sign in again in order to start bidding for salvages, thank you!");
                        }
                    });
                } else {
                    growlError("Something went wrong!");
                }
            },
            (_) => {
                try {
                    growlWarning("please fill required inputs");
                } catch {
                    ShowWarningNotification("please fill required inputs");
                }
            }
        )();
    };
    const comfirmPasswordBlurEvent = () => {
        const password = userGenericMethods.formHandler.getValues("password");
        const confirmPassword = userGenericMethods.formHandler.getValues("confirmPassword");
        if (password === "" && confirmPassword !== "") {
            growlWarning("password field is empty");
            userGenericMethods.formHandler.setValue("confirmPassword", "");
        } else if (password !== confirmPassword && confirmPassword !== "") {
            growlWarning("passwords do not match, please try again.");
            userGenericMethods.formHandler.setValue("confirmPassword", "");
        }
    };
    const signUpHandler = () => {
        signUp(userGenericMethods.formHandler);
    };
    const signUp = async (formHandler: UseFormReturn<FieldValues, object>) => {
        formHandler.handleSubmit(
            async (data) => {
                const formData = data as IUser;
                formData.createdBy = "siba salvage systems";
                if (signUpAccount) {
                    ShowInfoConfirmation("Sign up as a salvage bidder with us?", async () => {
                        const response: queryResponse<any> | any = await signUpAccount([formData]);
                        if (response.state) {
                            ShowInfoNotification("Please sign in with your new account right away to complete your salvage bidder registration in order to participate, thank you!.");
                        }
                    });
                } else {
                    growlError("Something went wrong!");
                }
            },
            (_) => {
                try {
                    growlWarning("please fill required inputs");
                } catch {
                    ShowWarningNotification("please fill required inputs");
                }
            }
        )();
    };
    let content = (
        <>
            {/* <Card sx={{ minWidth: 50 }}>
                <CardContent>
                    <h5 style={{ color: "red" }}>
                        <b>⚠️ NOTE:</b> Remember to sign in with your new account and click on the register button right away for the final step in your salvage bidder registration in order for you to participate, thank you!.
                    </h5>
                </CardContent>
            </Card> */}
            <Card className="RegisterBidderWarningMobile">
                    <div style={{width: "100%", height: "4px", backgroundColor: "#EF001C"}}>&nbsp;</div>
                    {/* <div style={{width: "5.7%", height: "80px", backgroundColor: "rgba(239, 0, 28, 0.06)", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <CrisisAlertIcon fontSize="large" sx={{color: "#EF001C"}} />
                    </div> */}
                    <div style={{width: "100%", backgroundColor: "white"}}>
                    <CardContent style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                        <CrisisAlertIcon fontSize="large" sx={{color: "#EF001C"}} />
                        <div style={{ color: "333333", fontWeight: "500", width: "85%" }}>
                        Remember to sign in with your new account and click on the register button right away for the final step in your salvage bidder registration in order for you to participate, thank you!
                        </div>

                        {/* <h5 style={{ color: "red" }}>
                            <b>⚠️ NOTE:</b> Remember to sign in with your new account and click on the register button right away for the final step in your salvage bidder registration in order for you to participate, thank you!.
                        </h5> */}
                    </CardContent>
                    </div>
                    
                    <Button 
                            sx={{ marginBottom: "15px", marginTop: "0px", width: "90%", '&:hover': {
                                backgroundColor: "rgba(239, 0, 28, 0.06)",    
                                color: "#EF001C", 
                                border: "1px solid #EF001C" 
                                } }} 
                            variant="contained" 
                            color="error" 
                            startIcon={<LoginIcon style={{fontSize: "20px"}} />}
                        onClick={navigateToLoginPage}
                    >
                                Login
                        </Button>
                </Card>
            <Card className="RegisterBidderWarningDesktop">
                <div style={{width: "0.3%", height: "80px", backgroundColor: "#EF001C"}}>&nbsp;</div>
                <div style={{width: "5.7%", height: "80px", backgroundColor: "rgba(239, 0, 28, 0.06)", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <CrisisAlertIcon fontSize="large" sx={{color: "#EF001C"}} />
                </div>
                <div style={{width: "94%", height: "80px", backgroundColor: "white"}}>
                <CardContent style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <p style={{ color: "333333", fontWeight: "500", width: "80%" }}>
                        Remember to sign in with your new account and click on the register button right away for the final step in your salvage bidder registration in order for you to participate, thank you!
                    </p>
                    <Button 
                        sx={{ marginBottom: "15px", marginTop: "0px", width: "15%", '&:hover': {
                            backgroundColor: "rgba(239, 0, 28, 0.06)",    
                            color: "#EF001C", 
                            border: "1px solid #EF001C" 
                            } }} 
                        variant="contained" 
                        color="error" 
                        startIcon={<LoginIcon style={{fontSize: "20px"}} />}
                        onClick={navigateToLoginPage}
                    >
                                Login
                    </Button>

                    {/* <h5 style={{ color: "red" }}>
                        <b>⚠️ NOTE:</b> Remember to sign in with your new account and click on the register button right away for the final step in your salvage bidder registration in order for you to participate, thank you!.
                    </h5> */}
                </CardContent>
                </div>
            </Card>
            <div style={{ padding: "30px 0px" }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        
                            <div className="registrationConfidentialAddressInfoSegmentationItemParent">
                                <div className="registrationConfidentialAddressInfoSegmentationItem" style={{marginBottom: "30px"}}>
                                <Typography variant="h5" component="div">
                                    Basic Information
                                </Typography>
                                <hr />
                                <Stack direction="column" spacing={2}>
                                    <SibaInput name="redirect" type={"hidden"} formHandler={userGenericMethods.formHandler as any} value={window.location.origin} />
                                    <SibaInput name="firstName" label="First Name" validationObj={{ required: true }} formHandler={userGenericMethods.formHandler as any} />
                                    <SibaInput name="lastName" label="Last Name" validationObj={{ required: true }} formHandler={userGenericMethods.formHandler as any} />
                                    <SibaInput name="userName" label="User Name" validationObj={{ required: true }} formHandler={userGenericMethods.formHandler as any} />
                                    <SibaSelect
                                    name="gender"
                                    label="Gender"
                                    formHandler={userGenericMethods.formHandler as any}
                                    optionsObj={[
                                        { label: "Male", value: "male" },
                                        { label: "Female", value: "female" },
                                        { label: "Other", value: "other" }
                                    ]}
                                    />
                                </Stack>
                                </div>
                                <div className="registrationConfidentialAddressInfoSegmentationItem">
                                <Typography variant="h5" component="div">
                                Confidential Information
                                </Typography>
                                <hr />
                                <Stack direction="column" spacing={2}>
                                    <SibaInput name="rediiirect" type={"hidden"} formHandler={userGenericMethods.formHandler as any} value={window.location.origin} />
                                    <SibaInput name="phoneNumber" label="Phone Number" validationObj={{ required: true }} formHandler={userGenericMethods.formHandler as any} type="tel" />
                                    <SibaInput name="email" label="Email" validationObj={{ required: true }} formHandler={userGenericMethods.formHandler as any} type="email" />
                                    <SibaInput
                                        name="password"
                                        label="Password"
                                        validationObj={{ required: true, onBlur: comfirmPasswordBlurEvent }}
                                        formHandler={userGenericMethods.formHandler as any}
                                        type="password"
                                    />
                                    <SibaInput
                                        name="confirmPassword"
                                        label="Confirm Password"
                                        validationObj={{ required: true, onBlur: comfirmPasswordBlurEvent }}
                                        formHandler={userGenericMethods.formHandler as any}
                                        type="password"
                                    />
                                </Stack>
                                </div>
                            </div>
                            
                            
                            <div style={{width : "100%", display: "flex",justifyContent: "center"}}>
                            <Button style={{ marginBottom: "15px", marginTop: "25px" }} className="registerActionButton" variant="contained" color="primary" onClick={signUpHandler} startIcon={<Icons.Save size={20} />}>
                                Create User Account
                            </Button>
                            </div>
                    </Grid>
                </Grid>
            </div>
        </>
    );
    if (userManagementUtil.getUserSession()) {
        content = (
            <>
                {/* <Card sx={{ minWidth: 50 }}>
                    <CardContent>
                        <h5 style={{ color: "red" }}>
                            <b>⚠️ NOTE:</b> Remember to logout and sign in finally in order to start bidding for salvages after the final registration step, thank you!
                        </h5>
                    </CardContent>
                </Card> */}
                <Card className="RegisterBidderWarningMobile">
                    <div style={{width: "100%", height: "4px", backgroundColor: "#EF001C"}}>&nbsp;</div>
                    {/* <div style={{width: "5.7%", height: "80px", backgroundColor: "rgba(239, 0, 28, 0.06)", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <CrisisAlertIcon fontSize="large" sx={{color: "#EF001C"}} />
                    </div> */}
                    <div style={{width: "100%", backgroundColor: "white"}}>
                    <CardContent style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                        <CrisisAlertIcon fontSize="large" sx={{color: "#EF001C"}} />
                        <div style={{ color: "333333", fontWeight: "500", width: "85%" }}>
                        Remember to logout and sign in finally in order to start bidding for salvages after the final registration step, thank you!
                        </div>

                        {/* <h5 style={{ color: "red" }}>
                            <b>⚠️ NOTE:</b> Remember to sign in with your new account and click on the register button right away for the final step in your salvage bidder registration in order for you to participate, thank you!.
                        </h5> */}
                    </CardContent>
                    </div>
                    
                    <Button 
                            sx={{ marginBottom: "15px", marginTop: "0px", width: "90%", '&:hover': {
                                backgroundColor: "rgba(239, 0, 28, 0.06)",    
                                color: "#EF001C", 
                                border: "1px solid #EF001C" 
                                } }} 
                            variant="contained" 
                            color="error" 
                            startIcon={<LogoutIcon style={{fontSize: "20px"}} />}
                            onClick={() => {
                                ShowWarningConfirmation("Are you sure you want to log out?", () => {
                                userManagementUtil.exitToPath(baseUrl.frontend);
                                });
                                }
                            }
                        >
                                    Logout
                        </Button>
                </Card>


                <Card className="RegisterBidderWarningDesktop">
                    <div style={{width: "0.3%", height: "80px", backgroundColor: "#EF001C"}}>&nbsp;</div>
                    <div style={{width: "5.7%", height: "80px", backgroundColor: "rgba(239, 0, 28, 0.06)", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <CrisisAlertIcon fontSize="large" sx={{color: "#EF001C"}} />
                    </div>
                    <div style={{width: "94%", height: "80px", backgroundColor: "white"}}>
                    <CardContent style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                        <div style={{ color: "333333", fontWeight: "500", width: "80%" }}>
                        Remember to logout and sign in finally in order to start bidding for salvages after the final registration step, thank you!
                        </div>
                        <Button 
                            sx={{ marginBottom: "15px", marginTop: "0px", width: "15%", '&:hover': {
                                backgroundColor: "rgba(239, 0, 28, 0.06)",    
                                color: "#EF001C", 
                                border: "1px solid #EF001C" 
                                } }} 
                            variant="contained" 
                            color="error" 
                            startIcon={<LogoutIcon style={{fontSize: "20px"}} />}
                            onClick={() => {
                                ShowWarningConfirmation("Are you sure you want to log out?", () => {
                                userManagementUtil.exitToPath(baseUrl.frontend);
                                });
                                }
                            }
                        >
                                    Logout
                        </Button>

                        {/* <h5 style={{ color: "red" }}>
                            <b>⚠️ NOTE:</b> Remember to sign in with your new account and click on the register button right away for the final step in your salvage bidder registration in order for you to participate, thank you!.
                        </h5> */}
                    </CardContent>
                    </div>
                </Card>
                <h3 className="mt-3">Basic Information</h3>
                <hr />
                <div className="registrationBasicInfo">
                    
                    <div className="registrationBasicInfoName">
                        <SibaInput
                            style={{ boxSizing: "border-box" }}
                            name="NameofBusiness"
                            label="Name of Business"
                            validationObj={{ required: true }}
                            formHandler={bidderRegisterFormMethods.formHandler as any}
                        />
                    </div>
                    <div className="bidRegisterDatePickerAndOthers registrationBasicInfoDobId" >
                        <SibaDatePicker
                            name="DateOfBirth"
                            label="Date Of Birth"
                            validationObj={{ required: true }}
                            formHandler={bidderRegisterFormMethods.formHandler as any}
                        />
                    </div>
                    <div className="bidRegisterDatePickerAndOthers registrationBasicInfoDobId">
                        <SibaInput
                            style={{ boxSizing: "border-box", width: "100%" }}
                            name="TaxIdentificationNumber"
                            label="Tax Identification"
                            validationObj={{ required: true }}
                            formHandler={bidderRegisterFormMethods.formHandler as any}
                        />
                    </div>
                </div>
                <div>
                    <Card sx={{ minWidth: 50 }}>
                        <CardContent>
                            <div className="registrationConfidentialAddressInfo">
                                
                                <div className="registrationConfidentialAddressInfoSegmentation">
                                    <h5>Confidential Information</h5>
                                    <hr />
                                    <div>
                                        <div className="registrationConfidentialAddressInfoSegmentationItemParent" style={{marginBottom: "20px"}}>
                                            <div className="registrationConfidentialAddressInfoSegmentationItem marginSpaceBottomFifteen">
                                                <SibaSelect
                                                    name="IdentificationType"
                                                    label="Identification Type"
                                                    formHandler={bidderRegisterFormMethods.formHandler as any}
                                                    optionsObj={[
                                                        { label: "Ghana Card", value: "Ghana Card" },
                                                        { label: "Passport", value: "Passport" }
                                                    ]}
                                                />
                                            </div>
                                            <div className="registrationConfidentialAddressInfoSegmentationItem">
                                                <SibaInput
                                                    style={{ boxSizing: "border-box" }}
                                                    name="IdentificationNumber"
                                                    label="Identification Number"
                                                    validationObj={{ required: true }}
                                                    formHandler={bidderRegisterFormMethods.formHandler as any}
                                                />
                                            </div>
                                        </div>
                                        {/* <div style={{ width: "100%", display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>
                                            <div style={{ width: "48.5%" }}>
                                                <SibaInput
                                                    style={{ boxSizing: "border-box" }}
                                                    name="TaxIdentificationNumber"
                                                    label="Tax Identification"
                                                    validationObj={{ required: true }}
                                                    formHandler={bidderRegisterFormMethods.formHandler as any}
                                                />
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="registrationConfidentialAddressInfoSegmentation">
                                    <h5>Address Details</h5>
                                    <hr />
                                    <div>
                                        <div className="registrationConfidentialAddressInfoSegmentationItemParent">
                                            <div className="registrationConfidentialAddressInfoSegmentationItem marginSpaceBottomFifteen">
                                                <SibaTextArea
                                                    style={{ boxSizing: "border-box" }}
                                                    name="ResidentialAddress"
                                                    label="Residential Address"
                                                    validationObj={{ required: true }}
                                                    minHeight="100px"
                                                    formHandler={bidderRegisterFormMethods.formHandler as any}
                                                />
                                            </div>
                                            <div className="registrationConfidentialAddressInfoSegmentationItem">
                                                <SibaTextArea
                                                    style={{ boxSizing: "border-box" }}
                                                    name="PostalAddress"
                                                    label="Postal Address"
                                                    minHeight="100px"
                                                    validationObj={{ required: true }}
                                                    formHandler={bidderRegisterFormMethods.formHandler as any}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px" }}>
                                <Button variant="contained" color="primary" component="label" className="registerActionButton" onClick={bidderRegisteration}>
                                    {" "}
                                    Register Bidder Info
                                </Button>
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </>
        );
    }


    return (
        <>
            <Box component="main" sx={{ p: 3 }}>
                <Toolbar />
                <div className="container">{content}</div>
            </Box>
        </>
    );
};

export default BidderRegistrationForm;
